module.exports = __webpack_public_path__ + "static/img/crossSelling_product2.e7b50076.jpg";